import React, { useState } from "react";
import "../../Styles/EventsForm.css";

const AdminEventsForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    type: "",
    venue: "",
    village: "",
    mandal: "",
    date: "",
    time: "",
    guest: "",
    attendance: "",
    status: "",
    description: "",
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="event-form-container">
      <div className="event-form-card">
        <div className="event-form-header">
          <h2>Add New Event</h2>
          <p>Schedule public meetings, inaugurations, and community events</p>
          <button
            className="event-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="event-form-grid">

            <div className="event-form-group">
              <label>Event Title *</label>
              <input
                type="text"
                name="title"
                placeholder="Enter Event Title"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Event Type *</label>
              <select name="type" onChange={handleChange}>
                <option>Select Type</option>
                <option>Inauguration</option>
                <option>Public Meeting</option>
                <option>Review Meeting</option>
                <option>Felicitation</option>
                <option>Grievance Camp</option>
                <option>Cultural Event</option>
                <option>Other</option>
              </select>
            </div>

            <div className="event-form-group">
              <label>Venue *</label>
              <input
                type="text"
                name="venue"
                placeholder="Enter Venue"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Chief Guest / Organizer</label>
              <input
                type="text"
                name="guest"
                placeholder="Enter Name"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="event-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Time *</label>
              <input
                type="time"
                name="time"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Expected Attendance</label>
              <input
                type="number"
                name="attendance"
                placeholder="Enter Expected Attendance"
                onChange={handleChange}
              />
            </div>

            <div className="event-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Upcoming</option>
                <option>Completed</option>
                <option>Cancelled</option>
              </select>
            </div>

            <div className="event-form-group">
              <label>Upload Event Photo</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="event-form-group event-full-width">
            <label>Event Description</label>
            <textarea
              rows="4"
              name="description"
              placeholder="Enter Event Description or Agenda"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="event-btn-group">
            <button type="submit" className="event-submit-btn">
              Submit
            </button>
            <button type="reset" className="event-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminEventsForm;